<template>
    <div class="query-list">
        <div class="training-bar" v-if="selectedItems.length">
            <section class="uncheck" @click="unselectAll">
                <span class="material-icons"> arrow_back </span>
                {{ $t("chatbotv2.uncheckAll") }}
            </section>
            <section class="select" @click="selectAll">{{ $t("chatbotv2.selectAll") }}</section>
            <section class="queries">+{{ selectedItems.length }} {{ $t("chatbotv2.queriesSelected") }}</section>
            <section class="actions">
                <a-popover
                    :visible="trainFormVisible"
                    :overlayClassName="'no-padding'"
                    placement="bottom"
                    @visibleChange="(isVisible) => (trainFormVisible = isVisible)"
                    trigger="click"
                >
                    <div slot="content">
                        <TrainForm
                            :all-stories="stories"
                            :on-cancel="() => (trainFormVisible = false)"
                            :on-train="startMultiTrain"
                        />
                    </div>
                    <div v-tippy="{ followCursor: true, placement: 'bottom-end' }" content="Train">
                        <span class="material-icons"> done </span>
                    </div>
                </a-popover>

                <div v-tippy="{ followCursor: true, placement: 'bottom-end' }" content="Ignore" @click="ignoreMultiRow">
                    <span class="material-icons"> visibility_off </span>
                </div>
                <div
                    class=""
                    v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                    content="Delete"
                    @click="deleteMultiRow"
                >
                    <span class="material-icons"> close </span>
                </div>
            </section>
        </div>
        <div class="row-header">
            <div>{{ $t("chatbotv2.userQuery") }}</div>
            <div data-sort="">
                {{ $t("chatbotv2.date") }}
                <span class="material-icons"> arrow_drop_down </span>
            </div>
            <div data-sort="">
                {{ $t("chatbotv2.unmatched") }}
                <span class="material-icons"> arrow_drop_down </span>
            </div>
        </div>
        <div class="rows">
            <QueryRowItem
                v-for="row in rows"
                :key="row.id"
                :row="row"
                :is-selected="isSelected(row)"
                :on-select-changed="onSelectChanged"
                :multi-select-mode="selectedItems.length > 0"
                :on-deleted="deleteSingleRow"
                :on-ignored="ignoreSingleRow"
                :on-trained="trainSingleRow"
                :stories="stories"
                @trained="isTrained = true"
            />
            <a-modal :visible="isModalShow">
                <p>Some contents...</p>
                <p>Some contents...</p>
                <p>Some contents...</p>
            </a-modal>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../utils/log2";
import QueryRowItem from "./QueryRowItem";
import TrainForm from "./TrainForm";
import { Modal } from "ant-design-vue";

const log = log2("QueryList");
export default {
    name: "QueryList",
    components: { QueryRowItem, TrainForm },
    props: {
        rows: {
            type: Array,
            required: false,
            default: () => [],
        },
        selectedItems: {
            type: Array,
            required: false,
            default: () => [],
        },
        onSelectChanged: {
            type: Function,
            required: false,
            default: () => {},
        },
        selectAll: {
            type: Function,
        },
        unselectAll: {
            type: Function,
        },
        deleteSingleRow: {
            type: Function,
        },
        ignoreSingleRow: {
            type: Function,
        },
        trainSingleRow: {
            type: Function,
        },
        stories: {
            type: Array,
            default: () => [],
        },
        deleteMultiRow: {
            type: Function,
        },
        ignoreMultiRow: {
            type: Function,
        },
        trainMultiRow: {
            type: Function,
        },
    },
    data() {
        return {
            trainFormVisible: false,
            isTrained: false,
            destroyText: this.$t("chatbotv2.trainingAlert"),
            isModalShow: false,
            destroyTitle: this.$t("message.importantWarning"),
            destroyButtonText: this.$t("message.notificationUnderstood"),
            destroyButtonOkText: this.$t("message.ok"),
        };
    },
    methods: {
        isSelected(row) {
            return this.selectedItems.includes(row._id);
        },
        startMultiTrain(storyId, storyVersion, blockId) {
            this.trainFormVisible = true;
            this.trainMultiRow(storyId, storyVersion, blockId);
            this.isTrained = true;
        },
    },
    watch: {
        isTrained: function (val) {
            if (val === true) {
                this.$emit("isAnyTrained");
            }
        },
    },
};
</script>

<style lang="scss">
.destroy-modal {
    width: 900px !important;
}

.ant-modal-confirm-btns {
    margin-top: 18px;
    width: 100%;
    display: flex;
    justify-content: center;
}

.query-list {
    //box-shadow: 0 0 0 1px rgb(0 0 0 / 5%), 0 4px 24px 2px rgb(0 0 0 / 20%);
    display: grid;
    grid-template: auto minmax(0, 1fr) / minmax(0, 1fr);
    height: 100vh;
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;

    .training-bar {
        align-items: center;
        background: #006cff;
        color: #fff;
        display: flex;
        flex-wrap: wrap;
        height: 50px;
        left: 0;
        padding: 0 30px;
        position: absolute;
        right: 0;

        section.uncheck {
            align-items: center;
            cursor: pointer;
            display: flex;
            grid-area: uncheck;
            transition: all 0.3s;

            &:hover {
                opacity: 0.8 !important;
            }

            .material-icons {
                font-size: 15px;
                margin-right: 10px;
                margin-top: 2px;
            }
        }

        section.select {
            cursor: pointer;
            grid-area: select;
            margin-left: 20px;
            transition: all 0.3s;

            &:hover {
                opacity: 0.8 !important;
            }
        }

        section.queries {
            grid-area: queries;
            margin-left: auto;
        }

        section.actions {
            align-items: center;
            display: flex;
            grid-area: actions;
            justify-content: center;
            margin-left: 20px;

            div {
                align-items: center;
                border: 1px solid #fff;
                border-radius: 100%;
                cursor: pointer;
                display: flex;
                height: 26px;
                justify-content: center;
                margin: 0 5px;
                transition: opacity 0.3s;
                width: 26px;

                .material-icons {
                    color: #fff;
                    font-size: 15px;
                }
            }
        }
    }

    .row-header {
        display: grid;
        grid-template: minmax(0, 1fr) / 1fr 140px 140px;
        max-width: 1200px;
        min-width: 600px;
        padding: 30px 50px 20px;
        user-select: none;

        div {
            align-items: center;
            color: #516173;
            display: flex;
            font-size: 15px;

            &[data-sort] {
                cursor: pointer;
                text-transform: capitalize;
                transition: all 0.3s;
            }
        }
    }

    .rows {
        max-width: 1200px;
        min-width: 600px;
        overflow-x: hidden;
        overflow-y: auto;
        padding: 0 50px;

        .training-row {
            align-items: center;
            border-left: 1px solid #dbe1e8;
            border-right: 1px solid #dbe1e8;
            border-top: 1px solid #dbe1e8;
            cursor: pointer;
            display: grid;
            grid-template: minmax(0, 1fr) / 70px minmax(0, 1fr) 140px 140px;
            height: 47px;
            user-select: none;

            &.hovered:not(.multiSelectMode) {
                grid-template: minmax(0, 1fr) / 70px minmax(0, 1fr) 150px;
            }
        }

        .training-row:first-child {
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
        }

        .training-row:last-child {
            border-bottom: 1px solid #dbe1e8;
            border-bottom-left-radius: 4px;
            border-bottom-right-radius: 4px;
        }
    }
}
</style>
<style lang="scss" scoped></style>
